import helpingHand from './collection-lend_a_helping_hand';
export default {
  'collection-lend_a_helping_hand' : helpingHand
};



// WEBPACK FOOTER //
// ./src/store/data/collections/index.js